import React from 'react';

const NotFound = () => {
    return (
        <div style={{textAlign:'center'}}> 
            <h2>Page is not found</h2>
            <h3>404</h3>
        </div>
    );
};

export default NotFound;